// extracted by mini-css-extract-plugin
module.exports = {"spriteList":"SpriteList_spriteList__2lyn2","spriteListRow":"SpriteList_spriteListRow__9FoYX"};